export const Category = [
  {
    name: 'Culture',
    img: 'https://media.npr.org/assets/img/2020/12/07/99percent_custom-ad44d7569e602b2698267142396e71e91c539149.jpg',
    color: '#e8562a',
  },
  {
    name: 'Business',
    img: 'https://m.media-amazon.com/images/I/41-7FShV-3L.jpg',
    color: '#c9b2ab',
  },
  {
    name: 'Education',
    img: 'https://m.media-amazon.com/images/M/MV5BMTc0Mjg1Nzc0MF5BMl5BanBnXkFtZTcwODM5OTcwOQ@@._V1_.jpg',
    color: '#8cabaa',
  },
  {
    name: 'Health',
    img: 'https://m.media-amazon.com/images/M/MV5BMjNjYjJkYTYtYjI5Zi00NWE4LWFiZjItMjM0N2VlZjgxY2U0XkEyXkFqcGdeQXVyNzg3NjQyOQ@@._V1_.jpg',
    color: '#62bf62',
  },
  {
    name: 'Comedy',
    img: 'https://deadline.com/wp-content/uploads/2023/03/LLZA-_Prime-Video-Brings-Trevor-Noah-Home-To-Host-Its-First-South-African-Original_LOL-Last-One-Laughing-South-Africa.jpg?w=1024',
    color: '#ed4c59',
  },
  {
    name: 'News',
    img: 'https://i.scdn.co/image/1b5af843be11feb6c563e0d95f5fe0dad659b757',
    color: '#ba7538',
  },
  {
    name: 'Science',
    img: 'https://t3.ftcdn.net/jpg/02/06/22/40/360_F_206224040_ejMSpHtBCxGpzM96b3rKPCkbqhfZNUpr.jpg',
    color: '#6c9dad',
  },
  {
    name: 'History',
    img: 'https://ssl-static.libsyn.com/p/assets/6/b/f/e/6bfe939ed4336498/HHA-1400px_b.jpg?crop=1:1,offset-y0',
    color: '#de577f',
  },
  {
    name: 'Religion',
    img: 'https://d1bsmz3sdihplr.cloudfront.net/media/podcast-shows/BP_podcast_cover_2-optimized.jpg',
    color: '#aeb4b5',
  },
  {
    name: 'Development',
    img: 'https://i.scdn.co/image/ab6765630000ba8a1d971613512218740199a755',
    color: '#74d0d6',
  },
  {
    name: 'Sports',
    img: './sports.jpeg',
    color: '#7dba3c',
  },
  {
    name: 'Crime',
    img: 'https://images.squarespace-cdn.com/content/v1/5b6a11479f87707f6722bd01/1541786848970-Y0SCCZBCEY6OAE790VFB/MFM.jpg?format=1000w',
    color: '#6c4bb8',
  },
];
